export default {
  back: 'Kembali',
  next: 'Selanjutnya',
  yes: 'Ya',
  no: 'Tidak',
  save: 'Simpan',
  track: 'Lacak',
}
